import { render, staticRenderFns } from "./ModalStampRequired.vue?vue&type=template&id=98de3096&scoped=true&"
import script from "./ModalStampRequired.vue?vue&type=script&lang=js&"
export * from "./ModalStampRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98de3096",
  null
  
)

export default component.exports